import * as angular from 'angular';
import { MODULE_NAME } from '../config/constants';

import './index.js';

angular.module(MODULE_NAME)
.controller('FeedsupportController', ['$scope', '$http', '$uibModal', '$location', '$state', '$stateParams', '$upload', '$timeout', 'AppStateService', 'UsersDataService', 'FeedSupportStateService', 'fdxUI', function($scope, $http, $uibModal, $location, $state, $stateParams, $upload, $timeout, AppStateService, UsersDataService, FeedSupportStateService, fdxUI) {

    fdxUI.setActiveTab('dashboards');
    fdxUI.setTitle('FeedSupport');
    $scope.$parent.active_tab = 'db_list';
    $scope.$parent.return_tab = '/feedsupport';
    $scope.$parent.title_text = 'FeedSupport';
    $scope.fs_navigation_tab = $stateParams['fs_navigation_tab'] || 'create_new_ticket';
    $scope.fs_ticket_number = $stateParams['fs_ticket_number'] || '';
    $scope.account_id = AppStateService.getAccount().id;

    const newUI = $state.current?.data?.newUI;

    if (newUI) {
        $scope.breadcrumbs = [
            {
                title: 'Feedsupport™',
                route: ['/', $scope.account_id, 'feedsupport-new']
            },
            {
                title: 'Existing tickets',
                route: ['/', $scope.account_id, 'feedsupport-new', 'tickets']
            }
        ]
    }

    // feedsupportNavService

    $scope.get_fs_ticket_pending = () => {
        return $scope.fs_ticket_number === '0';
    };

    $scope.fs_ticket_forbidden=false;
    $scope.get_fs_ticket_forbidden = () => {
        if($scope.fs_ticket_number === '0'){
            return true;
        }
        else if($scope.fs_ticket_number !== ''){
            return FeedSupportStateService.getTicketForbidden();
        }
        return false;

    };

    $scope.$watch('fs_ticket_number', () => {
        FeedSupportStateService.setTicketForbidden(false);
    });

    $scope.accountId = AppStateService.getAccountId();
    $scope.feedSupportTicketsLink = `/app/#/${$scope.accountId}/feedsupport/tickets`;

    /**
     * To see the new FeedSupport link, the user must meet all of the following requirements:
     * 1.) NOT have the feedsupport_categories feature flag
     */
    $scope.showVersionSwitchBanner = () => {
        return !AppStateService.getAccount().hasFeature('feedsupport_categories');
    }

    $scope.goToNewFeedSupportPage =  () => {
        $state.go('app.feedsupport-new', { account_id: AppStateService.getAccountId() });
    }

}]);
